import { Phone, Mail, MapPin } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-ink border-t border-line pt-20 overflow-hidden" data-testid="site-footer">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 pb-16">
          <div>
            <p className="text-xs uppercase tracking-widest text-secondary-foreground/60 mb-3">Call us</p>
            <a href="tel:07831522491" className="text-lg hover:text-flame transition-colors flex items-center gap-2">
              <Phone className="h-4 w-4 text-flame" /> 07831 522491
            </a>
          </div>
          <div>
            <p className="text-xs uppercase tracking-widest text-secondary-foreground/60 mb-3">Email</p>
            <a
              href="mailto:thanish@reddyconstructionsltd.com"
              className="text-lg hover:text-flame transition-colors flex items-center gap-2 break-all"
            >
              <Mail className="h-4 w-4 text-flame shrink-0" /> thanish@reddyconstructionsltd.com
            </a>
          </div>
          <div>
            <p className="text-xs uppercase tracking-widest text-secondary-foreground/60 mb-3">Office</p>
            <p className="text-lg flex items-center gap-2">
              <MapPin className="h-4 w-4 text-flame shrink-0" /> 19 North High Street, London E6 1HS
            </p>
          </div>
        </div>

        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 border-t border-line py-8 text-sm text-secondary-foreground/60">
          <p>© {new Date().getFullYear()} KTR Constructions. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <a href="#services" className="hover:text-white transition-colors">Services</a>
            <a href="#projects" className="hover:text-white transition-colors">Work</a>
            <a href="/admin" className="hover:text-white transition-colors" data-testid="footer-admin-link">Admin</a>
          </div>
        </div>
      </div>

      <div className="leading-none">
        <h2 className="font-heading font-black tracking-tighter text-[19vw] text-center leading-[0.8] pb-4 select-none whitespace-nowrap">
          KTR<span className="text-flame">.</span>
        </h2>
      </div>
    </footer>
  );
};
